module.exports = __webpack_public_path__ + "static/img/lcb_rz.0f8e30d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/lcb_rz.png
// module id = nj3s
// module chunks = 0